import type { TaskType } from '@api';
import { Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../../../../utils';
import { LinkableEntity } from '../../../LinkableEntity';
import { DetailRow } from '../DetailRow';
import { DetailSection } from '../DetailSection';

const TRANS_COLUMNS = 'TABLE.COLUMNS';

type TaskSystemMetadataPropsType = {
  task: TaskType;
};

export const TaskSystemMetadata: React.FC<TaskSystemMetadataPropsType> = ({
  task,
}) => {
  const { t } = useTranslation(['tasks', 'common']);
  const noDataPlaceholder = t('NO_DATA_PLACEHOLDER', { ns: 'common' });

  return (
    <DetailSection label={t('DETAILS.SYSTEM_METADATA')}>
      <Stack>
        <DetailRow label={t(`${TRANS_COLUMNS}.CREATED_BY`)}>
          {task.createdBy ? (
            <LinkableEntity linkableEntity={task.createdBy} />
          ) : (
            noDataPlaceholder
          )}
        </DetailRow>
        <DetailRow label={t(`${TRANS_COLUMNS}.CREATED_AT`)}>
          {formatDateTime(task.createdAt)}
        </DetailRow>
        <DetailRow label={t(`${TRANS_COLUMNS}.CLAIMED_BY`)}>
          {task.claimedBy ? (
            <LinkableEntity linkableEntity={task.claimedBy} />
          ) : (
            noDataPlaceholder
          )}
        </DetailRow>
        <DetailRow label={t(`${TRANS_COLUMNS}.CLAIMED_AT`)}>
          {task.claimedAt
            ? formatDateTime(task.claimedAt)
            : noDataPlaceholder}
        </DetailRow>
        <DetailRow label={t(`${TRANS_COLUMNS}.CLOSE_REASON`)}>
          {task.closeReason ?? noDataPlaceholder}
        </DetailRow>
        <DetailRow label={t(`${TRANS_COLUMNS}.CLOSED_BY`)}>
          {task.closedBy ? (
            <LinkableEntity linkableEntity={task.closedBy} />
          ) : (
            noDataPlaceholder
          )}
        </DetailRow>
        <DetailRow label={t(`${TRANS_COLUMNS}.CLOSED_AT`)}>
          {task.closedAt
            ? formatDateTime(task.closedAt)
            : noDataPlaceholder}
        </DetailRow>
      </Stack>
    </DetailSection>
  );
};
